import {TaskListActionTypes} from '../../constants/actionType';

export const SelectedTaskDefaultProps = {taskId: null, taskNumber: null, cardID: null};

export const SelectedCardDataExample = {ID: 1, pickTipID: 2, ejectTipID: 4};

const initialState = {
  selectedCards: {},
  selectedTasks: {},
  expandedCard: null,
};

const actions = {
  [TaskListActionTypes.SET_SELECTED_TASKS]: (state, action) => ({...state, selectedTasks: action.tasks}),
  [TaskListActionTypes.REMOVE_SELECTED_TASKS]: (state, action) => ({
    ...state,
    selectedTasks: state.selectedTasks.filter((task) => !action.taskIds.includes(task.ID)),
  }),
  [TaskListActionTypes.RESET_SELECTED_TASKS]: (state) => ({...state, selectedTasks: {}}),
  [TaskListActionTypes.ADD_SELECTED_CARDS]: (state, action) => ({
    ...state,
    selectedCards: {...state.selectedCards, ...action.cards},
  }),
  [TaskListActionTypes.REMOVE_SELECTED_CARDS]: (state, action) => ({
    ...state,
    selectedCards: state.selectedCards.filter((card) => !action.cardIds.includes(card.ID)),
  }),
  [TaskListActionTypes.RESET_SELECTED_CARDS]: (state) => ({...state, selectedCards: {}}),
  [TaskListActionTypes.SET_CARD_EXPANDED]: (state, action) => ({...state, expandedCard: action.ID}),
};

export default function taskListState(state = initialState, action = '') {
  const {type} = action;
  const func = actions[type];

  return func ? func(state, action) : state;
}
